"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getApns = exports.Apn = exports.Provider = exports.Iccid = exports.Nr = exports.Lte = exports.Wcdma = exports.Cdma = exports.Gsm = void 0;
const effect_1 = require("effect");
exports.Gsm = __importStar(require("./gsm"));
exports.Cdma = __importStar(require("./cdma"));
exports.Wcdma = __importStar(require("./wcdma"));
exports.Lte = __importStar(require("./lte"));
exports.Nr = __importStar(require("./nr"));
__exportStar(require("./common"), exports);
const NAMESPACE = 'Network.Cellular';
exports.Iccid = effect_1.Schema.Trim.pipe(effect_1.Schema.pattern(/^89\d{14,21}$/)).annotations({
    identifier: `${NAMESPACE}.Iccid`,
    description: 'Integrated Circuit Card Identification number',
});
exports.Provider = effect_1.Schema.Literal('1NCE', 'TELIT').annotations({
    identifier: `${NAMESPACE}.Provider`,
});
const PROVIDER_APN_MAP = {
    '1NCE': ['iot.1nce.net'],
    'TELIT': ['nxt20.net', 'nxt23.net', 'culligan.nxt'],
};
exports.Apn = effect_1.Schema.Literal(...Object.values(PROVIDER_APN_MAP).flat()).annotations({
    identifier: `${NAMESPACE}.Apn`,
});
const getApns = (provider) => PROVIDER_APN_MAP[provider];
exports.getApns = getApns;
//# sourceMappingURL=index.js.map